const initialState = {
  documents: [],
};

const Documents = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DOCUMENTS':
      return { documents: action.documents };
    default:
      return state;
  }
};

export default Documents;
